import DOMPurify from 'dompurify';
import { observer } from 'mobx-react';
import { FC, useEffect, useMemo } from 'react';
import { Prompt } from 'react-router-dom';
import OrderStatus from './components/OrderStatus/OrderStatus';
import TakerFleetApiKey from './components/TakerFleetApiKey/TakerFleetApiKey';
import YallowApiKey from './components/YallowApiKey/YallowApiKey';
import takerGoStore from './store/takerGoStore';
import { SCREENS } from '~/constants/screens';
import { localeStore } from '~/mobx/localesStore';
import { removeToast, toastError } from '~/utils/toasts';
import { getPromptProps } from '~/view/components/CustomPrompt/helper';
import LoadingOverlay from '~/view/components/LoadingOverlay/LoadingOverlay';
import Headers from '~/view/containers/Headers/Headers';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';
import { ToastDuration } from '~/view/containers/Toasts';
import SettingControlsBlock from '~/view/screens/SettingsScreen/containers/SettingControlsBlock/SettingControlsBlock';
import './style.scss';

const toastId: string = 'taker-go-toast-id';

const TakerGo: FC = observer((): JSX.Element => {
  useEffect(() => {
    const runEffect = async () => {
      await takerGoStore.fetchTakerGoSettings();
      toastError({ id: toastId, message: localeStore.t('takergo_switch_info'), duration: ToastDuration.LONG });
    };

    runEffect();

    return () => {
      takerGoStore.reset();
      removeToast(toastId);
    };
  }, []);

  const formattedLink = useMemo(
    () =>
      DOMPurify.sanitize(
        localeStore.t('go_to_dispatching', {
          link: (
            <a className="color-mainblue" href={SCREENS.DISPATCHING_RULES()} target="_blank">
              {localeStore.t('dispatching_rules')}
            </a>
          ),
        })
      ),
    []
  );

  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderBack title={localeStore.t('taker-go')} path={SCREENS.SETTINGS_INTEGRATIONS()} />
      </Headers>

      <p
        className="family-regular text-size-16 mt-6"
        dangerouslySetInnerHTML={{
          __html: formattedLink,
        }}
      />

      <div className="taker-go__fields-wrapper">
        <OrderStatus />
        <YallowApiKey />
        <TakerFleetApiKey />
      </div>

      <SettingControlsBlock onSubmit={takerGoStore.updateTakerGoSettings} />

      <LoadingOverlay visible={takerGoStore.isLoading} refreshing />
      <Prompt when={takerGoStore.isDataEdited} message={getPromptProps()} />
    </div>
  );
});

export default TakerGo;
